import { SquareMeterAreaContainer } from '../../containers/advancedFilters/SquareMeterAreaContainer';
import { IFilter } from '../../types/filters';

export const squareMeterArea: IFilter = {
  component: SquareMeterAreaContainer,
};
